// extracted by mini-css-extract-plugin
export default {"container":"ApiDoc_container__XZtLy","scroll-container":"ApiDoc_scroll-container__w91ju"};